/**
 * Private modules
 */
const {
  bearerToken,
  createQueryComponent,
  inactivityDuration,
  nickname,
  objectId,
  objectIds,
  password,
  reason,
  sourceAddress,
  systemGameId,
  userAgent,
  username,
} = require('../.private').components;

/**
 * Scopes
 */
const {
  ACCOUNTS_DEACTIVATED,
  ACCOUNTS_REMOVED,
  DEFAULT,
} = require('../../scopes');

module.exports = {
  activateAccountsBySystemGameId: {
    properties: {
      body: {
        properties: {
          objectIds,
          reason,
        },
        required: [
          'objectIds',
          'reason',
        ],
        type: 'object',
      },
      params: {
        properties: {
          systemGameId,
        },
        required: ['systemGameId'],
        type: 'object',
      },
    },
    required: [
      'body',
      'params',
    ],
    type: 'object',
  },
  authorizeAccount: {
    properties: {
      body: {
        properties: {
          bearerToken,
          sourceAddress,
          userAgent,
        },
        required: ['bearerToken'],
        type: 'object',
      },
      query: createQueryComponent(),
    },
    required: [
      'body',
      'query',
    ],
    type: 'object',
  },
  deactivateAccountsBySystemGameId: {
    properties: {
      body: {
        properties: {
          objectIds,
          reason,
        },
        required: [
          'objectIds',
          'reason',
        ],
        type: 'object',
      },
      params: {
        properties: {
          systemGameId,
        },
        required: ['systemGameId'],
        type: 'object',
      },
    },
    required: [
      'body',
      'params',
    ],
    type: 'object',
  },
  deauthorizeAccount: {
    properties: {
      body: {
        properties: {
          bearerToken,
        },
        required: ['bearerToken'],
        type: 'object',
      },
    },
    required: ['body'],
    type: 'object',
  },
  getAccountByUsername: {
    properties: {
      params: {
        properties: {
          username,
        },
        required: ['username'],
        type: 'object',
      },
      query: createQueryComponent(),
    },
    required: [
      'params',
      'query',
    ],
    type: 'object',
  },
  getAccountsBySystemGameId: {
    properties: {
      params: {
        properties: {
          systemGameId,
        },
        required: ['systemGameId'],
        type: 'object',
      },
      query: createQueryComponent([
        ACCOUNTS_DEACTIVATED,
        ACCOUNTS_REMOVED,
        DEFAULT,
      ]),
    },
    required: [
      'params',
      'query',
    ],
    type: 'object',
  },
  recoverAccountsBySystemGameId: {
    properties: {
      body: {
        properties: {
          objectIds,
          reason,
        },
        required: [
          'objectIds',
          'reason',
        ],
        type: 'object',
      },
      params: {
        properties: {
          systemGameId,
        },
        required: ['systemGameId'],
        type: 'object',
      },
    },
    required: [
      'body',
      'params',
    ],
    type: 'object',
  },
  refreshAccountApiKeyById: {
    properties: {
      params: {
        properties: {
          objectId,
        },
        required: ['objectId'],
        type: 'object',
      },
    },
    required: ['params'],
    type: 'object',
  },
  refreshAccountOneTimePasswordSecretById: {
    properties: {
      params: {
        properties: {
          objectId,
        },
        required: ['objectId'],
        type: 'object',
      },
    },
    required: ['params'],
    type: 'object',
  },
  removeAccountsBySystemGameId: {
    properties: {
      body: {
        properties: {
          objectIds,
          reason,
        },
        required: [
          'objectIds',
          'reason',
        ],
        type: 'object',
      },
      params: {
        properties: {
          systemGameId,
        },
        required: ['systemGameId'],
        type: 'object',
      },
    },
    required: [
      'body',
      'params',
    ],
    type: 'object',
  },
  updateAccountById: {
    properties: {
      body: {
        properties: {
          inactivityDuration,
          nickname,
        },
        required: [
          'inactivityDuration',
          'nickname',
        ],
        type: 'object',
      },
      params: {
        properties: {
          objectId,
        },
        required: ['objectId'],
        type: 'object',
      },
    },
    required: [
      'body',
      'params',
    ],
    type: 'object',
  },
  updateAccountPasswordById: {
    properties: {
      body: {
        properties: {
          password,
        },
        required: ['password'],
        type: 'object',
      },
      params: {
        properties: {
          objectId,
        },
        required: ['objectId'],
        type: 'object',
      },
    },
    required: [
      'body',
      'params',
    ],
    type: 'object',
  },
  updateAccountUsernameById: {
    properties: {
      body: {
        properties: {
          username,
        },
        required: ['username'],
        type: 'object',
      },
      params: {
        properties: {
          objectId,
        },
        required: ['objectId'],
        type: 'object',
      },
    },
    required: [
      'body',
      'params',
    ],
    type: 'object',
  },
};
